
import RouteService from '@/services/route.service'
import OfferCard from '@/components/offer/OfferCard'
import ArmEnum from '@/enum/ArmEnum'
import BannerView from '@/components/banner/BannerView'
import BANNER_TYPE from '@/enum/BannerType'
import capitalize from '@/utils/capitalize'
import { mapActions } from 'vuex'

export default {
  name: 'profile-username',
  components: { BannerView, OfferCard },

  head () {
    const title = this.$t('pages.userProfile.seo.metaTitle', { username: this.username })
    const description = this.$t('pages.userProfile.seo.metaDescription', { username: this.username })
    return {
      title,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' },

        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
      ]
    }
  },

  data () {
    return {
      username: null,
      userProfile: null,
      userOffers: undefined,
      userOffersIsLoading: true,
      userOffersIsLoaded: false,
      ARM: ArmEnum,
    }
  },

  computed: {
    userCreation () {
      if (!this.userProfile) return null
      return capitalize(this.$dayjs(this.userProfile.createdAt).format('MMMM YYYY'))
    },
    userLastSignInAt () {
      if (!this.userProfile) return null
      return this.$dayjs(this.userProfile.lastSignInAt).fromNow()
    }
  },

  async created () {
    this.BANNER_TYPE = BANNER_TYPE
    this.username = this.$route.params.username
  },

  async fetch () {
    await this.fetchUserOffers()
  },

  async asyncData ({ params, error }) {
    try {
      const { data } = await RouteService.getUserProfile(params.username)
      return { userProfile: data.user }
    } catch (e) {
      console.error(e)
      error({ statusCode: 404, message: 'Profile not found' })
    }
  },

  methods: {
    ...mapActions({
      gtmClick: 'gtm/clickItem',
    }),

    async fetchUserOffers () {
      if (!this.userProfile) {
        this.userOffersIsLoading = this.userOffersIsLoaded = false
        return
      }
      const { id } = this.userProfile
      this.userOffersIsLoading = true
      try {
        const { data } = await RouteService.getOffers(id)
        this.userOffers = data.offers
        this.userOffersIsLoaded = true
      } catch (e) {
        this.userOffersIsLoaded = false
      }
      this.userOffersIsLoading = false
    },

    async gtmImpression (isVisible, offer, index) {
      if (!isVisible) return
      await this.$store.dispatch('gtm/viewItemList', {
        item: offer,
        listId: 'profile_offers',
        list: 'Profile Offers',
        index,
      })
    }
  }
}
